import { createContext, FC, useContext, useReducer } from 'react';

import { sortBy } from 'lodash';

interface Row {
  label: string;
  value: string;
}

export interface DoctorContextProps {
  rows: Array<Row>;
  addRows: (rows: Array<Row>) => void;
}

export const context = createContext<DoctorContextProps>({ rows: [], addRows: () => {} });

const rowsReducer = (state: Array<Row>, additionalRows: Array<Row>): Array<Row> => {
  if (additionalRows.length) {
    // NOTE: This filters from the original state to allow for updates
    const dedupedState = state.filter(({ label }) => !additionalRows.some((newRow) => newRow.label === label));
    return sortBy([...additionalRows, ...dedupedState], 'label');
  }
  return state;
};

export const DoctorContext: FC<{ hydrateRows?: Array<Row> }> = ({ children, hydrateRows = [] }) => {
  const [rows, dispatch] = useReducer(rowsReducer, hydrateRows);

  return <context.Provider value={{ rows, addRows: dispatch }}>{children}</context.Provider>;
};

export const useDoctorContext = () => useContext(context);
